// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6ee1c5e4","117":"51030a9f","194":"55409ec6","297":"83c03dca","436":"4dd8381d"}[chunkId] + ".chunk.js";
};